/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.publicDepositGiftCard.internal

import features.publicDepositGiftCard.models.TransferActionResultModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest
import kangaroorewards.appsdk.core.network.base.PathParameter
import kangaroorewards.appsdk.core.network.base.replaceInPath

internal class PublicDepositGiftCardRequest : NetworkRequest() {

    suspend fun publicDepositGiftCard(
        overrideHeaders: Map<String, String>? = null,
        userId: String,
        messageId: String
    ): IOResult<TransferActionResultModel> {
        return safeNetworkCall {
            patch<TransferActionResultModel, Any>(
                endpoint = PublicDepositGiftCardEndpoint.replaceInPath(
                    PathParameter("userId", userId),
                    PathParameter("messageId", messageId),
                ),
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
